import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { interval } from 'rxjs';
import { AuthService } from '../../core/service/auth/auth.service';

const AUTO_LOGOUT_SECONDS = 10;

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    imports: [RouterLink],
    template: `
        <div class="min-h-screen bg-[#fafaf7] flex items-center justify-center px-4">
            <div class="max-w-sm w-full text-center space-y-6">
                <div class="w-20 h-20 rounded-3xl bg-red-50 flex items-center justify-center mx-auto">
                    <svg class="w-9 h-9 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                    </svg>
                </div>
                <div>
                    <h2 class="text-xl font-semibold text-stone-800">Accès refusé</h2>
                    <p class="text-stone-500 text-sm mt-2 leading-relaxed">
                        Vous n'avez pas les permissions nécessaires pour accéder à cette page.
                    </p>
                    <p class="text-stone-400 text-xs mt-3">
                        Déconnexion automatique dans {{ secondsLeft() }}s…
                    </p>
                </div>
                <div class="flex flex-col gap-3">
                    <button
                        type="button"
                        (click)="logoutNow()"
                        class="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-red-500 hover:bg-red-600 text-white text-sm font-medium py-2.5 transition-colors"
                    >
                        Se déconnecter
                    </button>
                    <a routerLink="/" class="inline-flex items-center justify-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors">
                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                        Retour à l'accueil
                    </a>
                </div>
            </div>
        </div>
    `
})
export class UnauthorizedComponent implements OnInit {
    private authService = inject(AuthService);
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    secondsLeft = signal(AUTO_LOGOUT_SECONDS);
    private loggingOut = false;

    ngOnInit(): void {
        interval(1000).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            const remaining = this.secondsLeft() - 1;
            this.secondsLeft.set(remaining);
            if (remaining <= 0) {
                this.logoutNow();
            }
        });
    }

    logoutNow(): void {
        if (this.loggingOut) return;
        this.loggingOut = true;
        this.authService.logout().subscribe({
            next: () => this.router.navigate(['/']),
            error: () => this.router.navigate(['/']),
        });
    }
}
